import { createEnvHelpers } from './env.helpers';

const {
  optionalString: optionalPublicString,
  requireString: _requirePublicString,
  requireUrl: _requirePublicUrl,
} = createEnvHelpers('public');

// Project-specific public exports
export const NEXT_PUBLIC_COGNITO_CLIENT_ID = optionalPublicString(
  'NEXT_PUBLIC_COGNITO_CLIENT_ID'
);
export const NEXT_PUBLIC_CAL_BASE_URL =
  optionalPublicString('NEXT_PUBLIC_CAL_BASE_URL') ||
  'https://cal.com/team/trusti';
export const NEXT_PUBLIC_TRUSTI_ENV = optionalPublicString(
  'NEXT_PUBLIC_TRUSTI_ENV'
);
